import {NSFunctions} from './utils/functions'
import {NSUserFunctionPermissions} from './user_function_permissions'
import { URN as NSURN } from './utils/urn';



export let NSGroups = {};

NSGroups.init = function()
{
    //NSGroupsPrivate.init();
	
	//this.init = 	                                    					function () { return NSGroupsPrivate.init.apply( NSGroupsPrivate, arguments ); };
	this.f_get_groups____for_SEARCH =		            					function () { return NSGroupsPrivate.f_get_groups____for_SEARCH.apply( NSGroupsPrivate, arguments ); };
	this.f_get_collections_by_group_for____SEARCH =							function () { return NSGroupsPrivate.f_get_collections_by_group_for____SEARCH.apply( NSGroupsPrivate, arguments ); };
	this.f_get_group_by_collection_dataset_and_collection____for_EXPORT =	function () { return NSGroupsPrivate.f_get_group_by_collection_dataset_and_collection____for_EXPORT.apply( NSGroupsPrivate, arguments ); };
	

    
	window.NSGroups_ = NSGroups;
	window.NSGroupsPrivate_ = NSGroupsPrivate;
	
}

let NSGroupsPrivate = 
{
	
	
	//functions:
	
	/**
		s_schema_internal_name -> schema internal name
		s_c_internal_name -> collection internal name
	*/
	f_get_group_by_collection_dataset_and_collection____for_EXPORT: function(s_schema_internal_name, s_c_internal_name)
	{
		if(s_schema_internal_name && s_schema_internal_name != "" && s_c_internal_name && s_c_internal_name != ""){
			let s_collection_urn = NSURN.f_create_table_urn(s_schema_internal_name, s_c_internal_name);
			var o_collection = NSUserFunctionPermissions.f_get_Collection_by_function_type_READ_and_collection_urn(s_collection_urn);
			var o_group = o_collection.group;
			
			return o_group;	
		}
	},
	/*
		s_ds_internal_name -> dataset internal name
		s_c_internal_name -> collection internal name
	*/
	f_get_group_by_collection_dataset_and_collection____for_SEARCH: function(s_ds_internal_name, s_c_internal_name)
	{
		var s_collection_urn = NSFunctions.f_UrnCreation_Collection(s_ds_internal_name, s_c_internal_name)
		var o_collection = NSUserFunctionPermissions.f_get_Collection_by_function_type_SEARCH_and_collection_urn(s_collection_urn);
		var o_group = o_collection.group;
		
		return o_group;
	},
	
	/*
		returns: [group]	-> group: {external_name, order}
	*/
	f_get_groups____for_SEARCH: function()
	{
		var f_a_groups_sort_by_order = function(a_groups)
			{
				var a_ = a_groups;
				
				var f_eb_cb = function(o_a,o_b){
					
					var i_a_order = (parseInt(o_a.order))? parseInt(o_a.order) : "Not a number";
					var i_b_order = (parseInt(o_b.order))? parseInt(o_b.order) : "Not a number";
					
					if(i_b_order == "Not a number")
					{
						return -1;
					}
					else if(i_a_order == "Not a number")
					{
						return 1;
					}
					else if(i_a_order>=i_b_order)
					{
						return 1;
					}
					else
					{
						return -1;
					}
				}
				a_.sort(f_eb_cb);
				
			}
		
		var f_a_groups_has_group_by_external_name = function(a_groups, s_group_external_name)
		{
			for(var i=0; i<a_groups.length; i++)
			{
				var o_group_i = a_groups[i];
				if(o_group_i.external_name == s_group_external_name)
				{
					return true;
				}
			}
			
			return false;
		}
		
		
		var a_groups_for_SEARCH = [];
		
		var a_ft_col = NSUserFunctionPermissions.f_get_Collections_by_function_type_READ();
		
		var a_search_collection = a_ft_col;
		for(var i=0; i<a_search_collection.length; i++)
		{
			var o_c_i = a_search_collection[i];
			/*
				returns group: 
				{
					external_name,
					order
				} -> group object, comes from:
						NSUserFunctionPermissions.private_objs.o_func_permissions.a_function_type[...objs.FunctionType].a_collection[...objs.Collection].group
			*/
			var o_group = o_c_i.group;
			
			/*
				if o_group == null
					-> collection has not a group configured on the database, therefore will not available
			*/
			if(o_group != null)
			{
				var s_group_external_name = o_group.external_name;
				var b_group_already_added = f_a_groups_has_group_by_external_name(a_groups_for_SEARCH, s_group_external_name);
				
				if(!b_group_already_added)
				{
					a_groups_for_SEARCH.push(o_group);
				}
				
			}
			
			
		}
		

		f_a_groups_sort_by_order(a_groups_for_SEARCH);
	
		return a_groups_for_SEARCH;
		
		
	},
	
	f_get_collections_by_group_for____SEARCH: function(s_group_external_name)
	{
		var a_collection_res = []
		
		var a_ft_col = NSUserFunctionPermissions.f_get_Collections_by_function_type_READ();
		
		var a_search_collection = a_ft_col;
		for(var i=0; i<a_search_collection.length; i++)
		{
			var o_c_i = a_search_collection[i];

			var o_group = o_c_i.group;
			
			/*
				if o_group == null
					-> collection has not a group configured on the database, therefore will not available
			*/
			if(o_group != null)
			{
				
				var s_group_external_name_i = o_group.external_name;
				
				if(s_group_external_name_i == s_group_external_name)
				{
					a_collection_res.push(o_c_i);
				}
				
			}
			
			
		}
		
		return a_collection_res;
	}
	
	
	
}